<template>
  <div>
    <vxe-modal
      ref="modal"
      v-model="formVisible"
      :title="`合同模板[${DocumentStatus}]`"
      resize
      remember
      width="100%"
      height="100%"
      @show="showModal"
    >
      <div class="formContainer resize-box" ref="boxRef">
        <div class="leftFormContainer resize-left" ref="resizeLeftRef">
          <el-form ref="FormRef" label-position="left" :rules="rules" :model="form" :disabled="!isCreator || submitted">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="标题" prop="contract_template_name">
                  <el-input placeholder="标题" size="mini" v-model="form.contract_template_name"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="上传" prop="content">
                  <el-button type="primary" size="mini" icon="el-icon-upload" @click="uploadWordTemp"
                    >上传word模板</el-button
                  >
                  <el-tooltip :content="tooltipContent" placement="right">
                    <el-button type="text" icon="el-icon-question" size="medium" circle></el-button>
                  </el-tooltip>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="fileTemp.display">
                <el-form-item label="模板文件:">
                  <el-link type="primary" @click="handleExportFile">{{ fileTemp.display }}</el-link>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="table-panel">
            <vxe-grid
              ref="xTable"
              resizable
              :column-config="{ minWidth: '80px' }"
              :data="tableData"
              :showOverflow="true"
              size="mini"
              :edit-config="{ trigger: 'dblclick', mode: 'cell', activeMethod: activeMethod, showIcon: true }"
              :mouse-config="{ area: true }"
              :tooltip-config="{
                showAll: true,
                theme: 'dark'
              }"
              highlight-hover-row
              highlight-current-row
              height="100%"
              :columns="gridColumns"
              :keyboard-config="{
                isArrow: true,
                isEnter: true,
                isTab: true,
                isClip: true,
                enterToTab: true,
                isEdit: true
              }"
              :scroll-y="{
                mode: 'wheel'
              }"
            >
            </vxe-grid>
          </div>
        </div>
        <div class="resize-vertical-bar" ref="rvbRef"></div>
        <div class="rightFormContainer resize-right" ref="resizeRightRef">
          <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="附件日志" name="first">
              <div class="attachments">
                <div class="file-container">
                  <FileList :ID="id" :isDisabled="!isCreator" ref="FileListRef" vuePath="ContractTemplate" />
                </div>
                <div class="timeline">
                  <YKDivider>
                    <div>日志</div>
                  </YKDivider>
                  <div class="timeline-panel">
                    <el-timeline :reverse="true">
                      <el-timeline-item v-for="(item, index) in form.timeLine" :key="index" :timestamp="item.logTime">
                        {{ `${item.operator}: ${item.logContent}` }}
                      </el-timeline-item>
                    </el-timeline>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="差异对比" name="second">
              <!--              <div class="content-title">-->
              <!--                {{ differenceNumber === 0 ? '无差异' : differenceNumber + '个差异' }}-->
              <!--              </div>-->
              <div class="difference-panel" ref="differenceDom">
                <div class="difference-content" v-html="differenceHtml"></div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>

      <!-- 页脚按钮 -->
      <div class="operate-area">
        <el-button type="primary" v-show="isCreator || id === 0" :disabled="submitted" @click="save">保存</el-button>
        <el-button type="danger" v-show="id > 0 && isCreator" :disabled="submitted" @click="del">删除</el-button>
        <el-button type="success" v-show="id > 0 && isCreator" :disabled="submitted" @click="submit">提交</el-button>
        <el-button
          type="success"
          v-show="id > 0 && ApprovalAuthority && form.approver_id === 0 && form.document_status === '提交'"
          @click="handleApprove(true)"
          >审批</el-button
        >
        <el-button
          type="danger"
          v-show="id > 0 && ApprovalAuthority && (form.document_status === '提交' || form.document_status === '审批')"
          @click="handleApprove(false)"
          >撤销审批</el-button
        >
        <!--        <el-button type="primary" @click="exportWord">导出Word</el-button>-->
        <!--        <el-button type="primary" v-show="id > 0 && isCreator" @click="displayDifference">比较内容</el-button>-->
        <el-button @click="formVisible = false">关闭</el-button>
        <!--        <el-button type="primary" v-show="id > 0" @click="exportWord">导出word</el-button>-->
      </div>
    </vxe-modal>
    <!--    <DisplayDifference-->
    <!--      v-model="differenceVisible"-->
    <!--      :old-html="form.contentOld"-->
    <!--      :original-html="originalHtml"-->
    <!--      :edit-html="editorHtml"-->
    <!--      :has-old="true"-->
    <!--    />-->
    <el-dialog :append-to-body="true" title="批注" :visible.sync="dialogVisible" width="30%">
      <div>
        <el-input v-model="comment" placeholder="请输入批注内容" type="textarea" :rows="2" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleComment">确 定</el-button>
      </span>
    </el-dialog>
    <input
      type="file"
      ref="uploadRef"
      v-show="false"
      id="open"
      multiple="multiple"
      @change="uploadFile"
      accept=".docx"
    />
  </div>
</template>

<script>
import FileList from '@/components/Form/FileList.vue'
import * as diff from 'diff'
import DisplayDifference from '@/views/ContractTemplate/DisplayDifference.vue'
import fileSaver from 'file-saver'
import htmlDocx from 'html-docx-js/dist/html-docx'
import HtmlDiff from 'htmldiff-js'
import Docxtemplater from 'docxtemplater'
import PizZip from 'pizzip'
import mammoth from 'mammoth'

const baseUrl = {}
export default {
  components: {
    FileList
  },
  data() {
    return {
      id: -1,
      // 表单
      form: {
        id: 0,
        document_status: '',
        contract_template_name: '',
        last_modify_time: '',
        content: '',
        contentOld: '',
        creator_id: 0,
        creator: '',
        createTime: '',
        approver: '',
        approver_id: 0,
        isModify: true,
        timeLine: []
      },
      tableData: [],
      gridColumns: [
        { type: 'seq', width: 40, fixed: 'left' },
        {
          field: 'variable_name',
          title: '可用变量'
        }
      ],
      tooltipContent: '在word中使用花括号 {} 来加入一个变量, 如 {姓名}, 设置变量格式时要连同 {} 一并设置',
      rules: {
        contract_template_name: [
          { required: true, message: '请输入标题', trigger: 'change' },
          {
            min: 0,
            max: 128,
            message: '长度在 0 到 128 个字符',
            trigger: 'change'
          }
        ],
        content: [{ required: true, message: '请上传模板', trigger: 'change' }]
      },
      formVisible: false,
      // 是否禁用编辑
      isDisabled: false,
      editor: null,
      // transcript: '',
      // lastContent: '',
      differenceVisible: false,
      // originalContent: [],
      comment: '',
      dialogVisible: false,
      isApprove: true,
      activeName: 'first',
      template: '',
      cacheFile: '',
      vuePath: 'ContractTemplateDetail',
      fileTemp: {
        aKeyValue: 0,
        aName: '',
        display: '',
        aClass: '',
        aPath: '',
        aType: '',
        aSize: '',
        aLength: '',
        sort: '',
        filePath: ''
      },
      currentHtml: '',
      oldHtml: '',
      hasReUpload: false
    }
  },
  methods: {
    handleResize() {
      const boxDom = this.$refs.boxRef
      const leftDom = this.$refs.resizeLeftRef
      const resizeDom = this.$refs.rvbRef
      const rightDom = this.$refs.resizeRightRef
      resizeDom.onmousedown = e => {
        const startX = e.clientX
        leftDom.left = leftDom.offsetWidth
        document.onmousemove = e => {
          const endX = e.clientX
          let moveLen = leftDom.left + (endX - startX)
          const maxWidth = boxDom.clientWidth - resizeDom.offsetWidth
          const minWidth = maxWidth * 0.2
          if (moveLen < minWidth) {
            moveLen = minWidth
          }
          if (moveLen > maxWidth - minWidth) {
            moveLen = maxWidth - minWidth
          }
          leftDom.style.width = (moveLen / maxWidth) * 100 + '%'
          rightDom.style.width = ((maxWidth - moveLen) / maxWidth) * 100 + '%'
        }
        document.onmouseup = () => {
          document.onmousemove = null
          document.onmouseup = null
          resizeDom.releaseCapture && resizeDom.releaseCapture()
        }
        resizeDom.setCapture && resizeDom.setCapture()
        return false
      }
    },
    // cell激活控制
    activeMethod({ column }) {
      if (!this.isCreator || this.isSubmit) {
        return false
      }
      return !(column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true)
    },
    async handleExportFile() {
      let upload = baseUrl.upload
      if (!upload) {
        upload = window.location.origin
      }
      if (this.id > 0) {
        const blob = await this.handleDownloadFile(this.fileTemp.filePath)
        fileSaver.saveAs(blob, `${this.form.contract_template_name}.docx`)
      } else {
        fileSaver.saveAs(this.cacheFile, `${this.form.contract_template_name}.docx`)
      }
    },
    async handleDownloadFile(path) {
      return new Promise((resolve, reject) => {
        let upload = baseUrl.upload
        if (!upload) {
          upload = window.location.origin
        }
        this.$http
          .get(`/base/attachment/secret`, {
            params: {
              urlstr: `${upload}/download/${path}`
            }
          })
          .then(res => {
            const url = res.data
            fetch(url)
              .then(res => res.blob())
              .then(blob => {
                resolve(blob)
              })
          })
      })
    },

    uploadWordTemp() {
      this.$refs.uploadRef.click()
    },
    async parsingTemplate(file) {
      if (!file) return
      this.tableData = []
      const reader = new FileReader()
      reader.onload = async e => {
        const arrayBuffer = e.target.result
        try {
          const result = await mammoth.convertToHtml({ arrayBuffer: arrayBuffer })
          this.currentHtml = result.value
          // 解析文档中的变量
          const variableRegex = /\{([^{}]+)\}/g
          const variables = []
          let match
          while ((match = variableRegex.exec(result.value)) !== null) {
            const variableName = match[1].trim()
            if (!variables.includes(variableName)) {
              variables.push(variableName)
            }
          }
          // 如果找到变量，添加到表格中
          if (variables.length > 0) {
            variables.forEach(variable => {
              this.tableData.push({
                id: 0,
                variable_name: variable,
                variable_value: variable
              })
            })
          }
        } catch (error) {
          console.error('解析文档时出错:', error)
          this.$message.error('解析文档失败')
        }
      }

      reader.onerror = () => {
        this.$message.error('读取文件失败')
      }

      reader.readAsArrayBuffer(file)
    },
    uploadFile(event) {
      let files = event.target.files
      if (files.length === 0) return
      const isDocxFile = files[0].type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      if (!isDocxFile) {
        this.$message.warning('请上传.docx文件')
        this.$refs.uploadRef.value = ''
        return
      }
      // const reader = new FileReader()
      // const options = {
      //   modules: []
      // }
      // reader.onload = e => {
      //   const arrayBuffer = e.target.result
      //   this.template = new Docxtemplater(new PizZip(arrayBuffer), options)
      // }
      // reader.readAsArrayBuffer(files[0])

      // 解析模板文件内容
      this.parsingTemplate(files[0])
      files[0].uuid = this.genreactUUID()
      this.hasReUpload = true
      this.cacheFile = files[0]
      this.fileTemp.display = files[0].name
      this.form.content = files[0].name
      this.$refs.uploadRef.value = ''
    },
    async handleUploadWordTemp(file, writeToDB = true) {
      let upload = baseUrl.upload
      if (!upload) {
        upload = window.location.origin
      }
      const guID = this.genreactUUID()
      let formData = new FormData()
      formData.append('file', file)
      formData.append('vuePathName', this.vuePath + '/temp')
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'accept-language': 'zh-CN',
          'loading': false
        },
        timeout: 0
      }
      const { data: res } = await this.$http.post(`${upload}/upload?X-Progress-ID=${guID}`, formData, config)
      if (res.isSuccess) {
        if (writeToDB) {
          await this.writeToDB(res.data)
        } else {
          return res.data
        }
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    async writeToDB(file) {
      let uploadTime = new Date().getTime() + ''
      const temp = {
        aKeyValue: this.id,
        aName: file.aName,
        aDisplay: file.aDisplay,
        aClass: file.aClass,
        aPath: file.aPath,
        aType: file.aType,
        aSize: file.aSize,
        aLength: file.aLength,
        sort: uploadTime
      }
      const { data: res } = await this.$http.post(`/base/attachment/bulk-insert`, [temp])
      if (res.isSuccess) {
        this.$message.success('上传成功')
        this.form.isModify = true
        this.cacheFile = ''
        await this.getFileListByApi()
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    async getFileListByApi() {
      const { data: res } = await this.$http.post('/base/attachment', {
        vuePath: this.vuePath + '/temp',
        keyValue: this.id
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      } else {
        if (res.data.length > 0) {
          if (res.data.length > 2) {
            const { data: del } = await this.$http.delete(`/base/attachment/${res.data[0].id}`)
            if (!del.isSuccess) {
              this.$message.error(del.errorMessage)
              return false
            }
          }
          this.fileTemp = res.data[res.data.length - 1]
        } else {
          this.fileTemp = {
            aKeyValue: 0,
            aName: '',
            display: '',
            aClass: '',
            aPath: '',
            aType: '',
            aSize: '',
            aLength: '',
            sort: '',
            filePath: ''
          }
        }
      }
    },
    async exportWord() {
      const blob = await this.handleDownloadFile()
    },
    // 获取附件
    getFileList() {
      this.$refs.FileListRef.init()
    },
    // 打开模态窗
    async openModal(id = 0) {
      this.id = id
      this.BindText()
      this.$nextTick(() => {
        this.formVisible = true
      })
    },
    async validEnter() {
      let flag = true
      await this.$refs.FormRef.validate().then(
        res => {
          flag = true
        },
        err => {
          flag = false
        }
      )

      if (!flag) {
        this.$message.error('验证失败,请核对输入数据')
      }
      return flag
    },
    // 保存
    async save() {
      const flag = await this.validEnter()
      if (flag) {
        if (this.tableData.length === 0) {
          this.$message.warning('模板没有可用变量')
          return
        }
        if (this.id && this.id > 0) {
          this.update()
        } else {
          this.add()
        }
      }
    },
    // 获取数据
    async BindText() {
      this.comment = ''
      this.tableData = []
      this.currentHtml = ''
      this.oldHtml = ''
      this.fileTemp = {
        aKeyValue: 0,
        aName: '',
        display: '',
        aClass: '',
        aPath: '',
        aType: '',
        aSize: '',
        aLength: '',
        sort: '',
        filePath: ''
      }
      if (this.id > 0) {
        const { data: res } = await this.$http.get('/Finance/Contract/Template', {
          params: {
            id: this.id
          }
        })
        if (res.isSuccess) {
          this.form = res.data
          this.hasReUpload = false
          await this.getFileListByApi()
          const currentFile = JSON.parse(this.form.content).path
          const blob = await this.handleDownloadFile(currentFile)
          await this.parsingTemplate(blob)
          const oldFile = JSON.parse(this.form.contentOld).path
          const blobOld = await this.handleDownloadFile(oldFile)
          const reader = new FileReader()
          reader.onload = async e => {
            const arrayBuffer = e.target.result
            try {
              const result = await mammoth.convertToHtml({ arrayBuffer: arrayBuffer })
              this.oldHtml = result.value
            } catch (error) {
              console.error('解析文档时出错:', error)
              this.$message.error('解析文档失败')
            }
          }
          reader.onerror = () => {
            this.$message.error('读取文件失败')
          }
          reader.readAsArrayBuffer(blobOld)
          // 解析模板
        } else {
          this.$message.error(res.errorMessage)
        }
      } else {
        this.form.id = 0
        this.originalHtml = ''
        // this.transcript = ''
        this.form.creator_id = this.$store.state.userInfo.userId
        this.form.creator = this.$store.state.userInfo.name
        this.form.document_status = '草稿'
        this.form.createTime = this.ykDateFormat('yyyy-MM-dd HH:mm:ss', new Date())
        this.form.content = ''
        this.form.contentOld = ''
        this.form.isModify = true
        this.form.contract_template_name = ''
        this.form.timeLine = []
        this.form.last_modify_time = this.ykDateFormat('yyyy-MM-dd HH:mm:ss', new Date())
      }
    },
    async submit() {
      const { data: res } = await this.$http.put(`/Finance/Contract/Template/submit/${this.id}`)
      if (res.isSuccess) {
        this.$emit('updateData')
        this.BindText()
        this.$message.success('提交成功')
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    handleComment() {
      if (this.comment === '') {
        this.$message.warning('请输入批注')
        return
      }
      if (this.isApprove) {
        this.approve()
      } else {
        this.revokeApproval()
      }
    },
    handleApprove(isApprove) {
      this.isApprove = isApprove
      this.dialogVisible = true
    },
    async approve() {
      const { data: res } = await this.$http.post('/Finance/Contract/Template/approve', {
        id: this.id,
        comment: this.comment
      })
      if (res.isSuccess) {
        this.$emit('updateData')
        this.$message.success('审批成功')
        this.BindText()
        this.dialogVisible = false
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    async revokeApproval() {
      const { data: res } = await this.$http.post('/Finance/Contract/Template/unapprove', {
        id: this.id,
        comment: this.comment
      })
      if (res.isSuccess) {
        this.$emit('updateData')
        this.$message.success('撤销成功')
        this.BindText()
        this.dialogVisible = false
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    // 新增
    async add() {
      try {
        const params = await this.handleUploadWordTemp(this.cacheFile, false)
        const jsonContent = {
          path: params.aPath,
          detail: this.tableData,
          newPath: ''
        }
        this.form.content = JSON.stringify(jsonContent)
        const { data: res } = await this.$http.post('/Finance/Contract/Template', this.form)
        if (res.isSuccess) {
          this.id = res.data
          await this.$refs.FileListRef.handleUploadCacheFileToDB() // 提交缓存附件
          this.$emit('updateData')
          this.writeToDB(params)
          this.BindText()
          this.$message.success(this.messageConfig.save.success)
        } else {
          this.$message.error(res.errorMessage)
          // this.editor.setHtml(temporaryHtml)
        }
      } catch (e) {
        this.$message.error(e)
      }
    },
    // 更新
    async update() {
      try {
        if (this.hasReUpload) {
          await this.handleUploadWordTemp(this.cacheFile)
        }
        const jsonContent = {
          path: this.fileTemp.filePath,
          detail: this.tableData,
          newPath: ''
        }
        this.form.content = JSON.stringify(jsonContent)
        const { data: res } = await this.$http.put('/Finance/Contract/Template', this.form)
        if (res.isSuccess) {
          this.$emit('updateData')
          this.BindText()
          this.$message.success(this.messageConfig.save.success)
        } else {
          this.$message.error(res.errorMessage)
          // this.editor.setHtml(temporaryHtml)
        }
      } catch (e) {
        this.$message.error(e)
      }
    },
    // 删除
    del() {
      this.$confirm('此操作将永久删除该单据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await this.$http.delete('/Finance/Contract/Template', {
          data: {
            id: this.id
          }
        })
        if (res.isSuccess) {
          this.$message.success(this.messageConfig.del.success)
          this.formVisible = false

          this.$emit('updateData')
        } else {
          this.$message.error(res.errorMessage)
        }
      })
    },
    // 提交缓存文件
    submitCacheFileToServer() {
      this.$refs.FileListRef.handleUploadCacheFileToDB()
    },
    showModal() {
      this.getFileList()
      this.$nextTick(() => {
        this.$refs.FormRef.clearValidate()
        this.handleResize()
      })
    }
  },
  computed: {
    isCreator() {
      return this.$store.state.userInfo.userId === this.form.creator_id
    },
    ApprovalAuthority() {
      return this.$store.state.userInfo.name === '林源晟' || this.$store.state.userInfo.name === '姚杨'
    },
    submitted() {
      return this.form.document_status === '提交' || this.form.document_status === '审批'
    },
    DocumentStatus() {
      let val = ''
      switch (this.form.document_status) {
        case '提交':
          val = '已提交'
          break
        case '审批':
          val = '已审批'
          break
        case '草稿':
          val = '草稿'
          break
        default:
          val = '草稿'
      }
      return val
    },
    differenceHtml() {
      return HtmlDiff.execute(this.oldHtml, this.currentHtml)
    }
  },
  watch: {}
}
</script>
<style lang="less" scoped>
@rightFormContainerWidth: 250px;

.bottomBtns {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.formContainer {
  height: calc(100% - 40px - 10px - 31px);
  display: flex;
}
.el-form-item {
  // margin: 0px !important;
  /deep/.el-form-item__content {
    display: flex;
    align-items: center;
  }
}
/deep/.el-icon-question {
  font-size: 22px !important;
}
.leftFormContainer {
  height: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 0 10px 10px 10px;

  overflow: auto;
  .table-panel {
    height: 100%;
  }

  /* 修改滚动条的宽度和颜色 */
  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #999;
  }

  /* 鼠标悬停时滚动条 thumb 的颜色 */
  &::-webkit-scrollbar-thumb:hover {
    background-color: #888;
  }
}
.rightFormContainer {
  height: 100%;
  box-sizing: border-box;
  padding: 0 10px;
}
.operate-area {
  display: flex;
  align-items: center;
  justify-content: center;
}
.attachments {
  width: 350px;
  height: calc(100vh - 188px);
}
.content-title {
  font-size: 16px;
  margin-top: 20px;
}
.difference-panel {
  overflow-x: hidden;
  overflow-y: auto;
  width: 99%;
  height: calc(100vh - 188px);
  border: 1px solid #ccc;
  .difference-content {
    padding: 0 10px;
  }
}
.mark-added {
  background-color: #ffe137;
}
.file-container {
  height: 50%;
}
.timeline {
  height: 50%;
  display: flex;
  flex-direction: column;
  .timeline-panel {
    flex-grow: 1;
    padding: 15px 0;
    border-radius: 10px;
    overflow: auto;
    background-color: #eee;
  }
}
.edit-area {
  z-index: 100;
}
/deep/.w-e-tag {
  margin: 0px 3px;
  font-size: 14px;
  background-color: rgb(236, 245, 255);
  color: rgb(64, 158, 255);
  border: 1px solid rgb(217, 236, 255);
  border-radius: 3px;
  padding: 3px 8px;
}
/deep/del.diffdel {
  color: red;
  text-decoration: underline line-through;
}
/deep/del.diffmod {
  color: red;
  text-decoration: underline line-through;
}
/deep/ins.diffmod {
  color: #00a900;
  text-decoration: underline;
}
/deep/ins.diffins {
  color: #00a900;
  text-decoration: underline;
}
.resize-box {
  width: 100%;
  display: flex;
}

.resize-left {
  width: 75%;
  min-width: 40%;
}

.resize-right {
  width: 25%;
  min-width: 25%;
}

.resize-vertical-bar {
  position: relative;
  width: 4px;
  cursor: col-resize;
  background-size: cover;
  background-position: center;

  &:hover {
    background-color: #45a3ff;
  }
}
</style>
